import './LayoutControls.scss';

import PropTypes from 'prop-types';

const LayoutControls = ({ layout, setLayout }) => {
  const layoutChecked = (layoutIx) => layout === layoutIx;

  return (
    <div className="gw-gallery__button-group ">
      <label htmlFor="layoutChoice1" className="gw-gallery__controls-label">
        <div className="gw-gallery__input-wrapper gw-gallery__input-wrapper--first">
          <input
            className="gw-gallery__controls-hidden-input"
            type="radio"
            id="layoutChoice1"
            name="layoutChoice1"
            value="layout1"
            checked={layoutChecked(1)}
            onChange={() => setLayout(1)}
          />
          I
        </div>
      </label>

      <label htmlFor="layoutChoice2" className="gw-gallery__controls-label">
        <div className="gw-gallery__input-wrapper">
          <input
            className="gw-gallery__controls-hidden-input"
            type="radio"
            id="layoutChoice2"
            name="layoutChoice2"
            value="layout2"
            checked={layoutChecked(2)}
            onChange={() => setLayout(2)}
          />
          II
        </div>
      </label>

      <label htmlFor="layoutChoice3" className="gw-gallery__controls-label">
        <div className="gw-gallery__input-wrapper gw-gallery__input-wrapper--last">
          <input
            className="gw-gallery__controls-hidden-input"
            type="radio"
            id="layoutChoice3"
            name="layoutChoice3"
            value="layout3"
            checked={layoutChecked(3)}
            onChange={() => setLayout(3)}
          />
          III
        </div>
      </label>
    </div>
  );
};

LayoutControls.propTypes = {
  layout: PropTypes.number,
  setLayout: PropTypes.func,
};

LayoutControls.defaultProps = {
  layout: 1,
  setLayout: () => null,
};

export default LayoutControls;
